import React from 'react'
import { PaymentElement } from '@stripe/react-stripe-js'
import { AppButton, AppDialogBody, AppDialogFooter } from '@easyllama/ui-components'
import { useSubmitPaymentMethod } from '~/hooks/useSubmitPaymentMethod'

const AddPaymentMethodForm = ({ onSuccess, onCancel }) => {
  const { handleSubmit, isSubmitting, stripe } = useSubmitPaymentMethod({ onSuccess })

  return (
    <>
      <AppDialogBody className='flex-1 min-h-0 overflow-y-auto'>
        <PaymentElement options={{ wallets: { applePay: 'never', googlePay: 'never', link: 'never' } }} />
      </AppDialogBody>
      <AppDialogFooter className='shrink-0 max-md:!flex-col-reverse'>
        <AppButton
          variant='secondary'
          onClick={onCancel}
          disabled={isSubmitting}
          className='max-md:w-full'
        >
          Cancel
        </AppButton>
        <AppButton
          onClick={handleSubmit}
          disabled={!stripe || isSubmitting}
          className='max-md:w-full'
        >
          {isSubmitting ? 'Saving...' : 'Add Card'}
        </AppButton>
      </AppDialogFooter>
    </>
  )
}

export default AddPaymentMethodForm
